import { render, staticRenderFns } from "./ExtensionOnboarding.vue?vue&type=template&id=7b934020&scoped=true"
import script from "./ExtensionOnboarding.vue?vue&type=script&lang=js"
export * from "./ExtensionOnboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b934020",
  null
  
)

export default component.exports